// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__sZ21A","pagination-link":"Pagination_pagination-link__d2D9j","pageBtn":"Pagination_pageBtn__oNycG","active":"Pagination_active__mMEyw"};